import { render, staticRenderFns } from "./caseVideo.vue?vue&type=template&id=e83952a2&lang=pug"
import script from "./caseVideo.vue?vue&type=script&lang=js"
export * from "./caseVideo.vue?vue&type=script&lang=js"
import style0 from "./caseVideo.vue?vue&type=style&index=0&id=e83952a2&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports